import { render, staticRenderFns } from "./GoogleOAuthButton.vue?vue&type=template&id=564fcd0c&scoped=true&"
import script from "./GoogleOAuthButton.vue?vue&type=script&lang=js&"
export * from "./GoogleOAuthButton.vue?vue&type=script&lang=js&"
import style0 from "./GoogleOAuthButton.vue?vue&type=style&index=0&id=564fcd0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564fcd0c",
  null
  
)

export default component.exports